export enum EnumAssinatura {
    NaoPermiteAssinatura = 0,
    PermiteAssinatura = 1,
}